import React, { Fragment, useState } from 'react';
import { TableBodyItem } from '../../Table.styles';
import { formatPrice } from '../../../../utils/util';
import { LastColumnItem, Row, TextLink, TooltipContainer, TooltipText } from './WithdrawalItem.styles';
import { ReactComponent as InfoIcon } from '../../../../assets/icons/info.svg';
import { Text14Regular } from '../../../utils/Text/Text.styles';

const WithdrawalItem = ({ status, amount, createdAt, onGoToWallet, massPayLoginUrl }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const STATUS = {
    APPROVED: 'Approved',
    REQUESTED: 'Requested',
    DECLINED: 'Declined',
  };

  return (
    <Fragment>
      <TableBodyItem>
        <p>{new Date(createdAt).toLocaleDateString()}</p>
      </TableBodyItem>
      <TableBodyItem>
        <p>${formatPrice(amount)}</p>
      </TableBodyItem>
      <TableBodyItem>
        <p>{STATUS[status]}</p>
      </TableBodyItem>
      <LastColumnItem>
        {status === 'APPROVED' && (
          <Row>
            {massPayLoginUrl ? (
              <TextLink href={massPayLoginUrl} target="_blank" rel="noopener noreferrer">
                Go to wallet
              </TextLink>
            ) : (
              <TextLink onClick={onGoToWallet}>Go to wallet</TextLink>
            )}
            <InfoIcon onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} />
            {showTooltip && (
              <TooltipContainer>
                <Text14Regular>Mass Pay Money Guide</Text14Regular>
                <TooltipText>
                  Your money is now available on mass pay. To login please use your email that you entered during
                  applying for Mass Pay.
                </TooltipText>
              </TooltipContainer>
            )}
          </Row>
        )}
      </LastColumnItem>
    </Fragment>
  );
};

export default WithdrawalItem;
